import React, { useState } from 'react';
import { SECTION_ID } from './RoomBlockSection.constants';
import {
  ExploreButton,
  EyebrowWrapper,
  LottieContainer,
  StyledSection,
  StyledTextPairing,
  TextContainer,
  ImageContainer,
} from './RoomBlockSection.styles';
import { NewFlag } from '@components/NewFlag';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { useTranslation } from 'react-i18next';

export const RoomBlockSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation('home');
  const { eyeBrow, title, body, linkText, link } = t('roomBlock');

  return (
    <StyledSection as="section" id={SECTION_ID} marginX={[0, 6]} marginBottom={6} isVisible={isVisible}>
      <LazyLoadWrapper beforeLoad={() => setIsVisible(true)}>
        <div />
      </LazyLoadWrapper>
      <TextContainer paddingY={[8, 0]}>
        <LottieContainer flexDirection="column" justifyContent={['flex-start', 'center']} alignItems={['center', 'flex-start']}>
          <EyebrowWrapper>
            <NewFlag
              flagColor="white"
              flagBackgroundColor="accentBlue4"
              belowSm={{ flagColor: 'white', flagBackgroundColor: 'accentBlue4' }}
              title={eyeBrow}
              titleColor="accentBlue4"
              titleVariant="sectionEyeBrow18"
              size={80}
            />
          </EyebrowWrapper>
          <StyledTextPairing
            titleVariant="calloutHed40Bold"
            titleColor="mono1"
            titleTagName="h3"
            title={title}
            body={body}
            bodyVariant="dek20"
            bodyColor="mono12"
            marginBottom={6}
            alignment={['center', 'left']}
            textAlign={['center', 'left']}
          />
          <ExploreButton id="homeRoomBlockBtn" forwardedAs="a" href={link} variant="secondaryMono" rounded>
            {linkText}
          </ExploreButton>
        </LottieContainer>
      </TextContainer>
      <ImageContainer isVisible={isVisible} />
    </StyledSection>
  );
};
